import { render, staticRenderFns } from "./opencicc.vue?vue&type=template&id=61845492&scoped=true"
import script from "./opencicc.vue?vue&type=script&lang=js"
export * from "./opencicc.vue?vue&type=script&lang=js"
import style0 from "./opencicc.vue?vue&type=style&index=0&id=61845492&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61845492",
  null
  
)

export default component.exports